// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#fileInput {\n  display: none;\n}\nh2 {\n  margin: 1em 0;\n}\n", ""]);
// Exports
module.exports = exports;
